import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { PieChart } from "react-chartkick";
import { fn } from "util";

import { If } from "components/support";

import style from "./style";

class Chart extends Component {
  render() {
    const { className, chartData } = this.props;
    const filteredChartData = [];

    for (const company of chartData) {
      filteredChartData.push([
        company.company_name,
        fn.centsToReal(company.revenues_value)
      ]);
    }

    return (
      <Paper elevation={1} className={`${className} pv-sm full-height`}>
        <Row>
          <Col xs={12}>
            <Typography type="title" className="pl-sm">
              Gráfico de Faturamento
            </Typography>
          </Col>
        </Row>

        <Row middle="xs" center="xs" className="chart-height full-height">
          <Col xs={12}>
            <If test={!(filteredChartData.length === 0)}>
              <PieChart data={filteredChartData} />
            </If>
            <If test={filteredChartData.length === 0}>
              <Typography type="caption" className="no-data-font-size">
                Nenhum dado encontrado
              </Typography>
            </If>
          </Col>
        </Row>
      </Paper>
    );
  }
}

export default style(Chart);



// WEBPACK FOOTER //
// ./src/components/app/management/multilocality-sales-report/chart/index.js